import React, { useEffect, useContext } from "react";
import PropTypes from "prop-types";

import { EligibilityContext } from "../../contexts/EligibilityContext";

import Role from "./Role";
import InModal from "../eligibility-wizard/InModal";

import { notDiseaseFund } from "../../helpers/fund";

const DiseaseFundOpenCard = ({ title, status, data }) => {
  const context = useContext(EligibilityContext);

  useEffect(() => {
    context.actions.setDiseaseFund({
      salesforceId: data.Id,
      fundId: data.Fund_ID,
      type: data.Type,
      groupId: data.Fund_ID,
      name: data.Name,
      fundStatus: data.Fund_Status.toLowerCase(),
      permalink: data.permalink,
      insuranceTypes: data.Public_Allowed_Insurance_Types.split(";"),
      medications: data.medications,
      eligibilityCriteria: data.eligibilityCriteria,
    });
  }, []);

  return (
    <div className="FundOpenCard Card bg-coral-light-50">
      <div className="Card-header bg-coral-light-50">
        <p className="f-h3">Check your eligibility</p>
        <p className="f-h4 u-mt1">
          Call{" "}
          <a className="FundOpenCard-link" href="tel:18663167263">
            1-866-316-7263
          </a>{" "}
          to apply today
        </p>
      </div>

      <div className="Card-inner bg-coral-light-50">
        <div className="Card-inner-content">
          <Role />
          <InModal />

          {notDiseaseFund(data.Fund_ID) && (
            <p className="u-mt3">
              Please note: While healthcare providers and pharmacies are
              encouraged to check their patient's eligibility and refer them to
              the program, patients or their caregiver must apply directly for
              transportation assistance.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

DiseaseFundOpenCard.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

export default DiseaseFundOpenCard;
